module.exports = __webpack_public_path__ + "static/about-us-banner-overlay-5d2cd43910508f9b7b5ff169ca0a19bf.png";